import { render, staticRenderFns } from "./TagPopup.vue?vue&type=template&id=20700a48&scoped=true"
import script from "./TagPopup.vue?vue&type=script&lang=js"
export * from "./TagPopup.vue?vue&type=script&lang=js"
import style0 from "./TagPopup.vue?vue&type=style&index=0&id=20700a48&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20700a48",
  null
  
)

export default component.exports